import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import ReactMasonry from 'react-masonry-css'
import clsx from 'clsx'

import { useMasonryNewStyles } from './masonry-new.styles'

type MasonryBreakpointCols =
  | { [key: number]: number }
  | { [key: string]: number }
  | number

type MasonryNewProps = {
  breakpointCols?: MasonryBreakpointCols
  columnClassName?: string
  className?: string
  columnAttrs?: Record<string, unknown>
}

export const MasonryNew: React.FC<MasonryNewProps> = (props) => {
  const theme = useTheme()
  const classes = useMasonryNewStyles()

  const breakpointCols = props.breakpointCols ?? {
    default: 4,
    [theme.breakpoints.values.xl]: 4,
    [theme.breakpoints.values.lg]: 3,
    [theme.breakpoints.values.md]: 2,
    [theme.breakpoints.values.sm]: 1
  }

  return (
    <ReactMasonry
      breakpointCols={breakpointCols}
      className={clsx(classes.root, props.className)}
      columnClassName={clsx(classes.column, props.columnClassName)}
    >
      {props.children}
    </ReactMasonry>
  )
}
